import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { checklistList, postChecklist, checklistQuestionsList,getTicketByAuditId,getTowerStructure as getTowerStructureApi, postCheckListQuestion, checklistQuestionById, postChecklistQuestionAnswer, checklistQuestionAnswersList, postChecklistCategory, checklistCategoryList, auditAnswerById, auditQuestionsAnswerById, checklistByID, deleteAnswer, postAudit, postAuditDetail, postAuditComment, postComplainApi, MyAuditList, getLocationList, getAuditById, getProjectList, getProjectStructuretList, getUnitList, getAuditScore, getAuditDetailByAuditId, startAudit, getReportbyId, postCategoryApi, updateCategoryApi, getCategorybyId, ComplainListApi, getAuditReport } from '../services/Apis';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { get } from 'lodash';


export default function useChecklist() {
    const queryClient = useQueryClient();
    const navigate = useNavigate()

    const initial_page = useSelector(state => state.globalslice.initial_page);
    const sorting_data = useSelector(state => state.globalslice.sorting_data);

    const getCheklist = (perPage) => {
        return useQuery({
            queryKey: ['checklistList', { page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updated_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }],
            queryFn: () => checklistList({ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updated_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const getChecklistById = (id) => {
        return useQuery({
            queryKey: ['getChecklistdById', { 'id': id }],
            queryFn: () => checklistByID(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const addChecklist = useMutation({
        mutationFn: async (payload) => {
            // If checklistId is 0, treat as add; else update
            return await postChecklist(payload);
        },
        onSuccess: () => {
            toast.success('Checklist saved successfully!');
            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] == 'checklistList') {
                }
            });
        },
        onError: () => {
            toast.error('Failed to save checklist.');
        },
    });

    const getChecklistQuestions = (checklistId, perPage) => {
        return useQuery({
            queryKey: ['getChecklistQuestions', { page: initial_page, limit: perPage, sort: sorting_data.sortBy, checklist_id: checklistId, search: sorting_data.search }],
            queryFn: () => checklistQuestionsList({ page: initial_page, limit: perPage, sort: sorting_data.sortBy, checklist_id: checklistId, search: sorting_data.search }),
            enabled: !!checklistId, // Only fetch if checklistId exists
            cacheTime: Infinity,
            refetchOnMount: true,
            staleTime: Infinity,
        });
    };

    const getChecklistQuestionById = (id) => {
        return useQuery({
            queryKey: ['getChecklistQuestionById', { 'id': id }],
            queryFn: () => checklistQuestionById(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const deleteAnswerbyid = (id) => {

        return useMutation({
            mutationFn: (id) => deleteAnswer(id),
            onSuccess: (_, id) => {
                queryClient.invalidateQueries(["auditQuestionAnswers"]);
            },
        });
    }

    const getAuditAnswerById = (id) => {
        return useQuery({
            queryKey: ['getAuditAnswerById', { 'id': id }],
            queryFn: () => auditAnswerById(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const getAuditQuestionsAnswersById = (id) => {
        return useQuery({
            queryKey: ['getAuditQuestionsAnswersById', { 'id': id }],
            queryFn: () => auditQuestionsAnswerById(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const addChecklistQuestion = useMutation({
        mutationFn: async (payload) => {
            // If qid is 0, treat as add; else update
            return await postCheckListQuestion(payload);
        },
        onSuccess: () => {
            toast.success('Checklist Question saved successfully!');
            queryClient.invalidateQueries(['checklistQuestions']);
        },
        onError: () => {
            toast.error('Failed to save checklist Question.');
        },
    });

    const getChecklistQuestionAnswers = (qId) => {
        return useQuery({
            queryKey: ['auditQuestionAnswers', { checklist_item_id: qId }],
            queryFn: () => checklistQuestionAnswersList({ checklist_item_id: qId }),
            enabled: !!qId,
            cacheTime: Infinity,
            staleTime: Infinity,
            refetchOnMount: false,
        });
    };

    const addChecklistQuestionAnswer = useMutation({
        mutationFn: async (payload) => {
            // If qid is 0, treat as add; else update
            return await postChecklistQuestionAnswer(payload);
        },
        onSuccess: () => {
            toast.success('Audit Question saved successfully!');
            queryClient.invalidateQueries(['auditQuestions']);
        },
        onError: () => {
            toast.error('Failed to save audit Question.');
        },
    });

    const addChecklistCategory = useMutation({
        mutationFn: async (payload) => {
            // If checklistId is 0, treat as add; else update
            return await postChecklistCategory(payload);
        },
        onSuccess: () => {
            toast.success('checklist category saved successfully!');
            queryClient.invalidateQueries(['ChecklistCategories']);
        },
        onError: () => {
            toast.error('Failed to save checklist categor.');
        },
    });

    const getChecklistCategoryList = (perPage) => {
        return useQuery({
            queryKey: ['checklistCategories', { page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updated_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }],
            queryFn: () => checklistCategoryList({ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updated_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const addAudit = useMutation({
        mutationFn: async (payload) => {
            // If checklistId is 0, treat as add; else update
            return await postAudit(payload);
        },
        onSuccess: () => {
            toast.success("Audit submitted successfully!");
            queryClient.invalidateQueries(['getAuditById']);
        },

    });

    const addAuditDetail = useMutation({
        mutationFn: async (payload) => {
            // If checklistId is 0, treat as add; else update
            return await postAuditDetail(payload);
        },
        onSuccess: () => {
            toast.success("Audit submitted successfully!");
            queryClient.invalidateQueries(['AuditList']);
        },
    });

    const addAuditComment = useMutation({
        mutationFn: async (payload) => {
            // If checklistId is 0, treat as add; else update
            return await postAuditComment(payload);
        },

    });

    const postTask = useMutation({
        mutationFn: (formData) => {

            return postComplainApi(formData);    // else — create

        },
        onSuccess: (data) => {
            toast.success('Complaint Updated Successfully', 200)
        }

    });

    const getMyAuditList = (perPage, project_id, date, audit_status,unitid) => {
        return useQuery({
            queryKey: ['AuditList', { project_id:project_id, date:date, audit_status:audit_status,unit_id:unitid, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'audit_startdate', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search}],
            queryFn: () => MyAuditList({project_id:project_id, date:date, audit_status:audit_status,unit_id:unitid, page: initial_page, limit: perPage ,sort: sorting_data?.sortBy ? sorting_data.sortBy : 'audit_startdate', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search}),
            staleTime: 0,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
        });
    };
    

    const getAuditCharts = (perPage, project_id, date, audit_status,unitid) => {
        return useQuery({
            queryKey: ['AuditLists', { project_id:project_id, date:date, audit_status:audit_status,unit_id:unitid, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'audit_startdate', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc'}],
            queryFn: () => MyAuditList({project_id:project_id, date:date, audit_status:audit_status,unit_id:unitid, limit: perPage ,sort: sorting_data?.sortBy ? sorting_data.sortBy : 'audit_startdate', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc'}),
            staleTime: 0,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
        });
    };
    
    const getTicketByAuditIdApi = (id,perPage) => {
        return useQuery({
            queryKey: ['TicketByAuditId',id, {  page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search  }],
            queryFn: () => getTicketByAuditId(id,{ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search  }),
            staleTime: 0,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
        });
    };

    const getChecklistDropdown = (type) => {
        return useQuery({
            queryKey: ['checklistDropdown', type, { limit: 5000 }],
            queryFn: () => checklistList(type, { limit: 5000 }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const locationList = (search) => {
        return useQuery({
            queryKey: ['locationList', { search: search }],
            queryFn: () => getLocationList({ search: search }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const auditById = (id) => {
        return useQuery({
            queryKey: ['getAuditById', { 'id': id }],
            queryFn: () => getAuditById(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getProjectDropdown = () => {
        return useQuery({
            queryKey: ['projectDropdown', { limit: 5000 }],
            queryFn: () => getProjectList({ limit: 5000 }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const getTowerDropdown = (project_id) => {
        return useQuery({
            queryKey: ["unitDropdown", {project_id:project_id, limit: 5000 }],
            queryFn: () => getProjectStructuretList({ project_id: project_id, limit: 5000 }),
            enabled: !!project_id, // only runs when project_id is set
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchOnMount: false,
        });
    };

  const getTowerStructure = (project_id) => {
        return useQuery({
            queryKey: ['TowerStructure', { 'project_id': project_id }],
            queryFn: () => getTowerStructureApi(project_id),
            enabled: !!project_id, // only runs when project_id is set
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchOnMount: false,
        });
    };

    const getUnitDropdown = (project_id, project_structure_id) => {
        return useQuery({
            queryKey: ["unitDropdown", {project_id, project_structure_id, limit: 5000 }], 
            queryFn: () => getUnitList({ project_id, project_structure_id, limit: 5000 }), 
            enabled: !!project_id , 
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchOnMount: false,
        });
    };

    const useAuditScore = (id) => {
        return useQuery({
            queryKey: ['getAuditScore', { 'id': id }],
            queryFn: () => getAuditScore(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const auditDetailByAuditId = (id) => {
        return useQuery({
            queryKey: ['getAuditDetailByAuditId', { 'id': id }],
            queryFn: () => getAuditDetailByAuditId(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };
    const useShareAuditReport = () => {
        return useMutation({
            mutationFn: (id) => getReportbyId(id),
            onSuccess: (response) => {
                const downloadUrl = response?.data?.download_url;
                const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
                    ` ${downloadUrl}`
                )}`;
                if (downloadUrl) {
                    window.open(whatsappUrl, "_blank");
                }
                toast.success("Generated Successfully");
            },
            onError: (error) => {
                toast.error("Print invoice failed");
                console.error(error);
            },
        });
    };

    const useAuditReport = () => {
        return useMutation({
            mutationFn: (id) => getReportbyId(id),
            onSuccess: (response) => {
                const downloadUrl = response?.data?.download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, "_blank");
                }
                toast.success("Generated Successfully");
            },
            onError: (error) => {
                toast.error("Print invoice failed");
                console.error(error);
            },
        });
    };

    const useStartAudit = useMutation({
        mutationFn: async (payload) => {
            return await startAudit(payload);
        },
        onSuccess: () => {
            toast.success('Audit has been started');

        },
        onError: () => {
            toast.error('Failed to start the audit.');
        },
    });

    const addCategory = useMutation({
        mutationFn: (formData) => {
            if (formData.id) {
                return updateCategoryApi(formData);
            } else {
                return postCategoryApi(formData);
            }
        },
        onSuccess: (data, variables) => {
            const isUpdate = !!variables.id;
            toast.success(isUpdate ? "Category Updated Successfully" : "Category Added Successfully");

            // 🔄 Invalidate all category-related queries
            queryClient.invalidateQueries({ queryKey: ['categories'] }); // <-- main list
            queryClient.invalidateQueries({ queryKey: ['categoryById'] });
            queryClient.invalidateQueries({ queryKey: ['categoriesDropdown'] });
        },
        onError: (error) => {
            console.error('Category mutation failed', error);
            toast.error('Something went wrong while saving category.');
        },
    });

    const getAuditTicket = (perPage, project_id, date, ticket_categoryid) => {
        return useQuery({
            queryKey: ['auditTickets', {project_id:project_id, date:date, ticket_categoryid:ticket_categoryid, ticket_source: 'audits', page: initial_page, limit: perPage }],
            queryFn: () => ComplainListApi({project_id:project_id, date:date, ticket_categoryid:ticket_categoryid,  ticket_source: 'audits', page: initial_page, limit: perPage }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const categoryById = (id) => {
        return useQuery({
            queryKey: ['categoryById', { 'id': id }],
            queryFn: () => getCategorybyId(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getAuditScoreByCategory = (perPage, project_id, date, category_id) => {
        return useQuery({
            queryKey: ['auditReport', {project_id:project_id, category_id:category_id, date:date, page: initial_page, limit: perPage }],
            queryFn: () => getAuditReport({project_id:project_id, category_id:category_id, date:date, page: initial_page, limit: perPage }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getAuditScoreByCategoryChart = (perPage, project_id, date, category_id) => {
        return useQuery({
            queryKey: ['auditReport', {project_id:project_id, category_id:category_id, date:date,  limit: perPage }],
            queryFn: () => getAuditReport({project_id:project_id, category_id:category_id, date:date,  limit: perPage }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getAuditTicketChart = (perPage, project_id, date, ticket_categoryid) => {
        return useQuery({
            queryKey: ['auditTickets', {project_id:project_id, date:date, ticket_categoryid:ticket_categoryid, ticket_source: 'audits',  limit: perPage }],
            queryFn: () => ComplainListApi({project_id:project_id, date:date, ticket_categoryid:ticket_categoryid,  ticket_source: 'audits', limit: perPage }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    return {
        getCheklist: getCheklist,
        addChecklist: addChecklist,
        getChecklistById: getChecklistById,
        getChecklistQuestions: getChecklistQuestions,
        getChecklistQuestionById: getChecklistQuestionById,
        getAuditAnswerById: getAuditAnswerById,
        addChecklistQuestion: addChecklistQuestion,
        getChecklistQuestionAnswers: getChecklistQuestionAnswers,
        addChecklistQuestionAnswer: addChecklistQuestionAnswer,
        addChecklistCategory: addChecklistCategory,
        getChecklistCategoryList: getChecklistCategoryList,
        getAuditQuestionsAnswersById: getAuditQuestionsAnswersById,
        deleteAnswerbyid: deleteAnswerbyid,
        getMyAuditList: getMyAuditList,
        getChecklistDropdown: getChecklistDropdown,
        addAuditDetail: addAuditDetail,
        addAudit: addAudit,
        addAuditComment: addAuditComment,
        postTask: postTask,
        auditById: auditById,
        getProjectDropdown: getProjectDropdown,
        getUnitDropdown: getUnitDropdown,
        useAuditScore: useAuditScore,
        getTowerDropdown: getTowerDropdown,
        auditDetailByAuditId: auditDetailByAuditId,
        useStartAudit: useStartAudit,
        useAuditReport: useAuditReport,
        addCategory: addCategory,
        getTicketByAuditIdApi:getTicketByAuditIdApi,
        categoryById: categoryById,
        getAuditTicket: getAuditTicket,
        getAuditScoreByCategory: getAuditScoreByCategory,
        useShareAuditReport:useShareAuditReport,
        getAuditCharts:getAuditCharts,
        getAuditScoreByCategoryChart,
        getAuditTicketChart,
        getTowerStructure: getTowerStructure,

    }
};
